export default "__VITE_ASSET__580e9322__"